<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <SmallSquare class='m-b-45' content='1.统一管理的礼品总库，可用于各个应用模块的关联调用，如上架到积分商城作为兑换或营销活动作为奖品发放。
         2.礼品加入回收站后，各个应用模块将不能再进行调用，但不影响之前已调用的礼品状态' />
      <div class='mb25 s_flex_ali'>
        <span class='mr15'>
          <a-button type="primary" v-has:createGift="()=> {$router.push('/product/gift/gift/management/createGift')}">
            <PlusOutlined />
            上传礼品
          </a-button>
        </span>
        <!-- <span class='mr15'>
          <a-button type="primary" @click="()=> {$router.push('/customer/dealer/level_add?type=add')}">
            <PlusOutlined />
            批量导入礼品
          </a-button>
        </span>
        <span class='mr15'>
          <a-button type="link" @click="()=> {$router.push('/customer/dealer/level_add?type=add')}">
            批量导入记录
          </a-button>
        </span> -->
      </div>
      <a-tabs @change="callback" v-model="active">
        <a-tab-pane key="1" tab="自有礼品">
        </a-tab-pane>
        <a-tab-pane key="2" tab="回收站">
        </a-tab-pane>
      </a-tabs>
      <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label="礼品名称" name='gift_name'>
          <a-input v-model:value="search.gift_name" style="width:280px" placeholder="请输入关键词进行搜索" />
        </a-form-item>
        <!-- <a-form-item label="礼品类型" name='level_id'>
          <a-select v-model:value="search.level_id" :style="{width:'140px'}" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option value="shanghai">Zone one</a-select-option>
            <a-select-option value="beijing">Zone two</a-select-option>
          </a-select>
        </a-form-item> -->
        <!-- <a-form-item label="礼品分类" name='level_id'>
          <a-cascader :options="loadData" :field-names="{ label: 'name', value: 'id', children: 'children' }" placeholder="请选择礼品分类" @change="onChange" />
        </a-form-item> -->
        <!-- <a-form-item label="礼品编码" name='keywords'>
          <a-input v-model:value="search.keywords" placeholder="请输入商品编码进行搜索" />
        </a-form-item> -->
        <a-form-item>
          <a-button type="primary" htmlType='submit'>搜索</a-button>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click='reset'>重置</a-button>
        </a-form-item>
        <!-- <a-form-item>
          <a-button type="primary" ghost>导出</a-button>
        </a-form-item> -->
      </a-form>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
        <template v-slot:gift_name="{record}">
          <a-card-meta>
            <template #avatar>
              <img :src="info.picdomain+'/'+(record.product_image||record.cover_image_url)" alt="" style="width:50px;height: 50px;object-fit:cover">
            </template>
            <template #description>{{record.gift_name}}</template>
          </a-card-meta>
        </template>
        <template v-slot:action="{ record }">
          <a v-has:editGift="()=>$router.push({path:'/product/gift/gift/management/createGift?id',query:{id:record.id}})" href="javascript:;" class="m-r-5">修改</a>
          <a v-has:recoveryGift="()=>recovery(record,'del')" href="javascript:;" v-if='active==1' class="m-r-5">删除</a>
          <a v-has:recoveryGift="()=>recovery(record,'re')" href="javascript:;" v-if='active==2' class="m-r-5">还原</a>
          <a v-has:delGift="()=>del(record)" href="javascript:;" v-if='active==2' class="m-r-5">删除</a>
        </template>
      </a-table>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `"  />
    </a-card>
  </a-layout>
</template>
<script>
import { PlusOutlined} from "@ant-design/icons-vue";
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { getRouter } from "@/utils/app";
import {
  getGift,
  getGiftRecoveryList,
  deleteGift,
  createGiftRecovery,
  getGiftCate,
} from "@/api/product";
import { iscode } from "@/utils/app";
import store from "@/store";
// 初始化默认筛选项数值
let defSearch = {
  gift_name: "",
  stock_num: "",
  page: 1,
  limit: 10,
};
export default {
  components: {
    PlusOutlined,
  },
  setup(props, ctx) {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    // 列表数据和列头配置
    let data = ref([]);
    const state = reactive({
      info: store.state.user.info,
      listLoading: false,
      time: [],
      total: 1,
      loadData: [],
    });
    let columns = [
      {
        title: "ID",
        dataIndex: "id",
        key: "id",
      },
      {
        title: "礼品名称",
        dataIndex: "gift_name",
        key: "gift_name",
        slots: { customRender: "gift_name" },
      },
      {
        title: "礼品库分类",
        dataIndex: "age",
        key: "age",
        customRender: ({ record }) => {
          return record.category.name;
        },
      },
      {
        title: "价格/元",
        dataIndex: "market_price",
        key: "market_price",
      },
      {
        title: "库存",
        dataIndex: "stock_num",
        key: "stock_num",
      },
      {
        title: "排序",
        dataIndex: "sort",
        key: "sort",
      },
      {
        title: "操作",
        key: "action",
        slots: { customRender: "action" },
      },
    ];
    const $router = inject("$router");
    const $Modal = inject("$Modal");
    const momentTime = inject("momentTime");

    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    // 获取分类

    const initCate = async () => {
      let result = await getGiftCate().then((res) => res.data);
      state.loadData = result.data;
    };
    //删除
    const recovery = (e, type) => {
      $Modal.confirm({
        centered: true,
        content: `您确定要将该礼品${
          type == "del" ? "移入回收站？" : "从回收站还原"
        }`,
        onOk: async () => {
          let res = await createGiftRecovery({ id: e.id }).then(
            (res) => res.data
          );
          if (iscode(res)) {
            initData(search.value);
            $Modal.destroyAll();
          }else{
            message.error(res.msg)
          }
        },
      });
    };
    const del = (e) => {
      $Modal.confirm({
        centered: true,
        content: `您确定要将该礼品删除后无法还原`,
        onOk: async () => {
          let res = await deleteGift(e.id).then((res) => res.data);
          if (iscode(res)) {
            initData(search.value);
            $Modal.destroyAll();
          }else{
            message.error(res.msg)
          }
        },
      });
    };
    // tabs 点击
    const active = ref(1);
    const callback = (e) => {
      active.value = e;
      reset();
      initData(search.value);
    };
    const form = ref();
    const reset = () => {
      form.value.resetFields();
    };
    const initData = async (values) => {
      state.listLoading = true;
      data.value = [];
      state.total = 0;
      try {
        let res;
        if (active.value == 1) {
          res = await getGift(values).then((res) => res.data);
        } else {
          res = await getGiftRecoveryList(values).then((res) => res.data);
        }
        state.listLoading = false;
        if (iscode(res)) {
          data.value = res.data.data;
          state.total = res.data.total;
        } else {
          message.error(res.msg);
        }
      } catch (e) {
        state.listLoading = false;
      }
    };
    onMounted(() => {
      initData(search.value);
      initCate();
    });
    return {
      ...toRefs(state),
      search,
      data,
      columns,
      recovery,
      del,
      active,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      momentTime,
      callback,
      reset,
      form,
    };
  },
};
</script>